import {
  SET_PROFILE_FROM_REDUX,
  SET_PROFILE_FROM_DB,
  SET_PROFILES,
  UPDATE_PROFILE,
  LOADING_PROFILE,
  SET_PROFILE_NOT_FOUND,
  SET_ERRORS,
} from '../types'
import { toast } from 'react-toastify'
import { handleError } from '../../utilities/errorHandler/errorHandler'

import 'react-toastify/dist/ReactToastify.css'
toast.configure()

// export const template = () => {
//     return  (dispatch, getState, { getFirebase, getFirestore }) => {
// const firebase = getFirebase()
// const firestore = getFirestore()
//     }
// }

export const updateProfile = (profile) => {
  return {
    type: UPDATE_PROFILE,
    payload: profile,
  }
}

export const getProfiles = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    dispatch({ type: LOADING_PROFILE })
    return firestore
      .collection('Users')
      .where('role', '==', 'Signer')
      .get()
      .then((querySnapshot) => {
        const profiles = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        dispatch({
          type: SET_PROFILES,
          payload: profiles,
        })
      })
      .catch((error) => {
        handleError(error, dispatch, toast, SET_ERRORS)
        dispatch({
          type: SET_PROFILES,
          payload: [],
        })
      })
  }
}

export const getReadyProfile = (userId) => (dispatch) => {
  dispatch({ type: LOADING_PROFILE })
  dispatch({
    type: SET_PROFILE_FROM_REDUX,
    payload: userId,
  })
}

export const getDirectProfile = (userId, setShow) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    dispatch({ type: LOADING_PROFILE })
    firestore
      .collection('Users')
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const profile = { id: userId, ...doc.data() }
          dispatch({
            type: SET_PROFILE_FROM_DB,
            payload: profile,
          })
          setShow(true)
        } else {
          dispatch({
            type: SET_PROFILE_NOT_FOUND,
          })
        }
      })
      .catch((error) => {
        handleError(error, dispatch, toast, SET_ERRORS)
        dispatch({
          type: SET_PROFILE_FROM_DB,
          payload: null,
        })
      })
  }
}
